import { render, staticRenderFns } from "./DueCreateSixthStep.vue?vue&type=template&id=29c396a2&"
import script from "./DueCreateSixthStep.vue?vue&type=script&lang=js&"
export * from "./DueCreateSixthStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports